import React from "react";
import Icon from "./icon";
import { useLocation } from '@reach/router';

import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton
} from "react-share";

import * as styles from "../styles/components/social-share.module.css";

const SocialShare = (props) => {

  const {
    title
  } = props;

  const url = useLocation().href;

  return (
    <div className={styles.root}>
      <h6>Share</h6>
      <ul className={styles.icons}>
        <li>
          <TwitterShareButton 
            url={url}
            title={title}
          >
            <Icon symbol="twitter-share" />
          </TwitterShareButton>
        </li>
        <li>
          <LinkedinShareButton 
            url={url}
            title={title}
          >
            <Icon symbol="linkedin-share" />
          </LinkedinShareButton>
        </li>
        <li>
          <FacebookShareButton 
            url={url}
            quote={title}
          >
            <Icon symbol="facebook-share" />
          </FacebookShareButton>
        </li>
        <li>
          <EmailShareButton
            url={url}
            subject={title}
          >
            <Icon symbol="email-share" />
          </EmailShareButton>
        </li>
      </ul>
    </div>
  );
}

export default SocialShare;
